<template>
  <app-industry-profile-template class="app-industry-profile-template-airlines"
          title="80% are not frequent flyers<span class='color-green'>!</span>"
          industryName="Airlines"
          casesRouteName="AirlinesCases"
          :brands="brands">

    <p>
      <strong>80% of your customers are not frequent flyers!</strong><br><br>

      Your primary focus is on your frequent flyers, as they are your most important customers.
      However, you have a huge untapped potential in the 80% infrequent travelers and in the ancillary
      revenue and transactional data readily available and waiting for you.
    </p>

    <p>
      <strong>Learn how</strong><br>
    </p>

    <img v-on:keyup.enter="videoThumbnailOnClick"
         v-on:click.prevent="videoThumbnailOnClick" alt="Airlines video image"
         src="@/assets/images/video-thumbnails/airlines.jpg" tabindex="0">

    <br>
    <br>

    <p class="no-margin">
      <strong>We can help you monetize the 80%!</strong><br><br>

      We can activate the 80% and let you monetize the infrequent travelers generating additional cash flow and adding
      asset value to your current program through transactional data and member engagement.<br><br>

      We have the market leading technology (as an add-on to your existing systems), 
      the needed experience, the knowhow, and a partnership mindset.<br><br>

      Let’s start a conversation today!
    </p>

    <div id="airlines-video" class="wistia_embed popover=true wistia_async_j5xr8ui4ix" style="visibility: hidden; height: 0;">&nbsp;</div>
  </app-industry-profile-template>
</template>

<script>
  import AppIndustryProfileTemplate from '@/components/layout/templates/view/AppViewTemplateIndustryProfile';

  /* Models */
  import Brands from '@/models/brands';

  export default {
    name: 'AirlinesProfile',

    components: {
      AppIndustryProfileTemplate
    },

    data: function() {
        return {
            brands: {
                title: 'Featured cases',
                items: [],
            },
        }
    },

    methods: {
      videoThumbnailOnClick() {
        window.wistiaInit = function(W) {
          let video = W.api("airlines-video");

          video.play();

          video.bind("popovershow", function() {
            //console.log("The popover for ", video.hashedId(), " is visible!");
          });

          video.bind("popoverhide", function() {
            //console.log("The popover for ", video.hashedId(), " is hidden!");
          });
        };
      },

      getBrands() {
        this.brands.items = new Brands().getIndustries('Airline');
      }
    },

    created() {
      this.getBrands();
    },

    beforeDestroy() {
      document.getElementById('airlines-video_popover_container').remove();
    }
  }
</script>

<style lang="scss">
  .app-industry-profile-template-airlines {
    min-height: calc(100vh - 100px);

    @media (min-width: $lgBreakpoint) {
      .banners {
        background-image: url("../../../assets/images/industries/banners/airlines.jpg");
      }
    }

    img {
      max-width: 100%;
      display: block;
      cursor: pointer;

      &:hover, &:focus {
        opacity: 0.7;
      }
    }
  }
</style>
